import Const from 'constants';

const UseOpposingGoalie = {
    setUseOpposingGoalieFromStorage(value) {
        return {
            type: Const.SET_USE_OPPOSING_GOALIE,
            opposingPlayers: value,
        };
    },

    useOpposingGoalie(value) {
        return (dispatch) => {
            dispatch({
                type: Const.SET_USE_OPPOSING_GOALIE,
                opposingPlayers: value ? null : 0,
            });

            dispatch(
                this.saveDataToStorage('useOpposingGoalie', function (state) {
                    const {filters} = state.lineupsData;

                    return filters.opposingPlayers;
                }),
            );
        };
    },
};

export default UseOpposingGoalie;
